/**
 * Loudness of the game audio buses, in one place: createGameAudio plays with these and the
 * offline checks (e2e audio lab) render with them, so the measurements match the game.
 */
import { volumeToGain } from './volume';

/** Settings defaults (GameSettings) until the engine passes the real ones. */
export const DEFAULT_VOLUMES = { sfx: 0.8, music: 0.5 } as const;

/**
 * Bus gain at full volume. At the default volumes gameplay effects peak 9-15 dB above the
 * music's average level (measured offline, see e2e/audio.spec.ts), the music stays behind.
 */
const SFX_LEVEL = 2;
const MUSIC_LEVEL = 0.9;
/** Music gain while somebody else talks in the voice chat (about -9 dB). */
const DUCK_LEVEL = 0.35;

export function sfxBusGain(volume: number): number {
  return volumeToGain(volume) * SFX_LEVEL;
}

export function musicBusGain(volume: number, ducked: boolean): number {
  return volumeToGain(volume) * MUSIC_LEVEL * (ducked ? DUCK_LEVEL : 1);
}
